import React from "react";

/**
 * Shown when the user has multiple connections for a platform and must pick one.
 * Displays only the platform name and each account label as a clickable button.
 */
export default function ConnectionSelectionCard({ platform, options, onSelect, disabled }) {
  return (
    <div className="rounded-xl border border-blue-200 bg-blue-50 p-4 max-w-sm">
      <p className="text-[0.82rem] font-semibold text-blue-700 uppercase tracking-wide mb-2">
        {platform}
      </p>
      <p className="text-[0.9rem] text-gray-700 mb-3 font-medium">
        Select an account to use:
      </p>
      <div className="flex flex-col gap-2">
        {options.map((opt, i) => (
          <button
            key={i}
            onClick={() => !disabled && onSelect(opt.label)}
            disabled={disabled}
            className={`text-left px-4 py-2 rounded-lg border text-[0.9rem] font-medium transition-colors
              ${disabled
                ? "border-gray-200 bg-gray-50 text-gray-400 cursor-not-allowed"
                : "border-blue-300 bg-white text-gray-800 hover:bg-blue-100 hover:border-blue-500 cursor-pointer"
              }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
